<div class="select-card" [class.select-card--disabled]="disabled" [attr.aria-disabled]="disabled || null">
  <div class="select-card__icon">
    <img [src]="icon" alt="" />
  </div>
  <div class="select-card__content">
    <strong class="select-card__title">{{ title }}</strong>
    <p class="select-card__description" [innerHTML]="description"></p>
    <p *ngIf="disabled && disabledMessage" class="select-card__warning">{{ disabledMessage }}</p>
  </div>
  <div class="select-card__corner">
    <ng-content></ng-content>
  </div>
  <span class="select-card__arrow" *ngIf="showArrow && !disabled" aria-hidden="true">&#10095;</span>
</div>
